// Shared marketing section: "Used by teams at" + org logos. Used by Landing and Subscribe.
// Each logo is a transparent PNG (white/checkerboard backgrounds knocked out, trimmed to
// its bounds) rendered as a uniform white silhouette via brightness-0 invert. Fixed-size
// cells + object-contain keep every logo consistently sized and evenly spaced regardless
// of its native aspect ratio.
const LOGOS = [
  { src: '/logos/cvs-health.png', alt: 'CVS Health' },
  { src: '/logos/concentrix.png', alt: 'Concentrix' },
  { src: '/logos/ruggable.png', alt: 'Ruggable' },
  { src: '/logos/university-of-phoenix.png', alt: 'University of Phoenix' },
  { src: '/logos/intouch-cx.png', alt: 'Intouch CX' },
  { src: '/logos/nike.png', alt: 'Nike' },
  { src: '/logos/volkswagen.png', alt: 'Volkswagen' },
  { src: '/logos/seahawks.png', alt: 'Seattle Seahawks' },
  { src: '/logos/qxo.png', alt: 'QXO' },
  { src: '/logos/aetna.png', alt: 'Aetna' },
  { src: '/logos/schnitzer.png', alt: 'Schnitzer Steel' },
];

export default function SocialProof() {
  return (
    <div className="w-full max-w-4xl mb-16">
      <p className="text-sm font-heading font-bold uppercase tracking-widest text-gray-300 mb-8 text-center">
        Used by teams at
      </p>
      <div className="flex flex-wrap justify-center gap-x-8 gap-y-7">
        {LOGOS.map(({ src, alt }) => (
          <div key={alt} className="h-12 w-36 flex items-center justify-center">
            <img
              src={src}
              alt={alt}
              className="max-h-full max-w-full object-contain brightness-0 invert opacity-90"
            />
          </div>
        ))}
      </div>
    </div>
  );
}
